import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getAllHistory(patientId, params, cancelToken) {
        return Axios.get(`${baseURL}record/history/${patientId}`, {
            params,
            cancelToken
        }).then(response => response.data.response);
    },
    getHistoryCount(patientId) {
        return Axios.get(`${baseURL}record/history-count/${patientId}`).then(
            response => {
                return response.data.response;
            }
        );
    },
    getRecordDetails(recordId) {
        return Axios.get(`${baseURL}record/medical-record/${recordId}`).then(
            response => response.data.response
        );
    },
    deleteRecord(recordId) {
        return Axios.delete(`${baseURLci}patient/record/remove`, {
            params: { id: recordId }
        }).then(response => response.data);
    },
    getMedicalNote(patientId, noteId) {
        return Axios.get(
            `${baseURL}record/medical-note/${patientId}/${noteId}`
        ).then(response => response.data.response);
    },
    getMedicalNoteList(patientId) {
        return Axios.get(
            `${baseURL}record/medical-note-list/${patientId}`
        ).then(response => response.data.response);
    },
    duplicateMedicalNote(params) {
        return Axios.post(
            `${baseURLci}patient/soap/save_duplicate`,
            params
        ).then(response => response.data);
    },
    deleteMedicalNote(noteId) {
        return Axios.delete(`${baseURL}record/medical-note/${noteId}`).then(
            response => response.data.response
        );
    },
    getVitals(patientId, params) {
        return Axios.get(`${baseURL}patient/${patientId}/vital`, {
            params
        }).then(response => response.data.response);
    },
    deleteVital(patientId, vitalId) {
        return Axios.delete(
            `${baseURL}patient/${patientId}/vital/${vitalId}`
        ).then(response => response.data.response);
    },
    updateVital(patientId, params) {
        return Axios.put(`${baseURL}patient/${patientId}/vital`, params).then(
            response => response.data.response
        );
    },
    saveVital(patientId, params) {
        return Axios.post(`${baseURL}patient/${patientId}/vital`, params).then(
            response => response.data.response
        );
    },
    getCommunications(patientId, params) {
        return Axios.get(
            `${baseURL}communication/patient-communication/${patientId}`,
            {
                params
            }
        ).then(response => response.data.response);
    },
    getItemDispensingStatuses(patientId) {
        return Axios.get(
            `${baseURL}reference/item-dispensing-statuses/${patientId}`
        ).then(response => response.data.response);
    }
};
